import React from 'react';

function Terms() {
    return (
        <div className="page-wrapper page-terms">
            <h2 className="title">Terms of Use</h2>
            <div>
                <h3 className="subtitle">Reservation Services</h3>
                <ul>
                    <li>
                        <h4>Restaurant Reservations</h4>
                        <p>
                            Superb provides the Reservation Services to User for the purpose of
                            assisting User in securing dining reservations at participating
                            third-party restaurants (each, a “Restaurant”). In response to a User's
                            online request for a Restaurant reservation through the Superb Site or
                            Superb Booking Application, Superb directly contacts the Restaurant's
                            computerized database of reservations. The availability of reservations
                            is determined at the time of User's query. Once a reservation is made by
                            User through the Superb Site or Superb Booking Application, Superb will
                            provide confirmation of the reservation to User by email and phone via
                            SMS. By using the Reservation Services, User agrees to receive
                            reservation confirmations by email and phone after booking a reservation
                            through the Reservation Services.
                        </p>
                    </li>
                    <li>
                        <h4>No-Show Policy</h4>
                        <p>
                            Superb is committed to providing superior quality services to Users and
                            Restaurants. To assist us in maintaining a consistently high level of
                            service for the Restaurants and their patrons. Users must cancel any
                            reservations that they will be unable to honor in accordance with the
                            Restaurant's cancellation policy which will be disclosed in the
                            confirmation email and is visible during the booking process.If your
                            reservation exceed the time of the cancellation time it will not be
                            possible to cancel the reservation, unless other agreement is made with
                            the Restaurant. Superb is not responsible for these agreements thereof.
                        </p>
                        <p>
                            You may cancel your reservation via the email confirmation, text
                            confirmation, on your profile on the Restaurant's booking platform or by
                            contacting the Restaurant directly.
                        </p>
                        <p>
                            The Restaurant may require a debit or credit card number to finalize
                            your reservation. In order to use the Reservation Services for these
                            Restaurants, you must provide valid debit or credit card information,
                            and you may be required to cancel your reservation in accordance with
                            the Restaurant's cancellation policy, which will be disclosed at the
                            time the reservation is made.
                        </p>
                        <p>
                            Superb's integrated payment provider uses your debit or credit card
                            information as described in our privacy policy and shall have no
                            liability for any charges made to the debit or credit card account for
                            any failure to cancel your reservation in accordance with a Restaurant's
                            cancellation policy. By using the Reservation Services, User agrees to
                            receive no-show notifications by email after a report that your
                            reservation was not honored, whether or not that was in fact the case.
                            User agrees that all final no-show determinations will be made by the
                            Restaurant in its sole discretion.
                        </p>
                    </li>

                    <li>
                        <h4>
                            Purchase of Restaurant Experiences Through Superb Booking Application
                        </h4>
                        <p>
                            You may purchase electronic Experiences issued by the Restaurant (each,
                            a "Experience") through the Superb Site and Superb Booking Application.
                            When you purchase an electronic Restaurant Experience, we notify the
                            person you have designated as the recipient of the Superb Experience by
                            email. It is the Restaurant who create the content of the Experiences
                            and not Superb.
                        </p>

                        <ol>
                            <li>
                                Restaurant Experiences are non-refundable, however you are always
                                welcome to contact the restaurant if you have any inquiries.
                            </li>
                            <li>
                                Superb has no obligation or responsibility to settle any dispute or
                                disagreement between the User and Restaurant.
                            </li>
                            <li>
                                Experiences may be given to another party. (Superb has no
                                responsibility in this matter and the agreement is solely between
                                User and third party). User must inform Restaurant about these
                                changes.
                            </li>
                            <li>
                                Experiences are only valid at the specific date or time for the
                                reservation (unless other is arranged with the Restaurant)
                            </li>
                        </ol>
                    </li>
                    <li>
                        <h4>USAGE GUIDELINES</h4>
                        <p>
                            User agrees to use the Reservation Services only to book reservations at
                            Restaurants and then honor those reservations by arriving at the
                            Restaurants on time and ordering and paying for meals. User further
                            agrees not to book more than one reservation for User's personal use
                            during any one meal time (e.g., lunch, dinner, etc.). Resale or
                            attempted resale of reservations is prohibited and is grounds for, among
                            other things, cancellation of your reservations or termination of your
                            access to the Services.
                        </p>
                    </li>
                </ul>
            </div>
            <div>
                <h3 className="subtitle">Payment Services</h3>
                <ul>
                    <li>
                        <h4>General Descriptions and Requirements</h4>
                        <p>
                            The Payment Services allow Users to pay bills at participating
                            Restaurants through the Superb Booking Application. In order to use the
                            Payment Services at a participating Restaurant, you must: (1) make a
                            reservation for the Restaurant through the Reservation Services; (2)
                            provide valid payment card information through the Superb Booking
                            Application as further described below; (3) provide and verify your
                            mobile phone number as further described below; and (4) have an Account
                            in good standing. The Payment Services may not be available for all
                            Restaurants. There is no fee to you to use the Payment Services, but
                            your mobile carrier's standard text message and data charges may apply;
                            you are responsible for any fees charged by your mobile carrier in
                            connection with your use of the Payment Services and Superb Booking
                            Application.
                        </p>
                    </li>
                    <li>
                        <h4>PAYMENT CARD INFORMATION</h4>
                        <p>
                            In order to use the Payment Services, you must provide account
                            information for at least one valid debit or credit card through or to
                            the Superb Booking Application. Superb uses this debit or credit card
                            account information as described in our privacy policy. If you provide
                            account information for a debit or credit card to the Superb Booking
                            Application via a third party, your provision of such debit or credit
                            card shall also be subject to the terms and conditions specified by such
                            third party. Superb takes no responsibility and assumes no liability for
                            any actions or omissions of such third party. You may add, delete, and
                            edit the debit or credit card account information you have provided from
                            time to time directly through the Superb Booking Application. If you
                            provide account information in such manner for more than one valid debit
                            or credit card, you must select which debit or credit card you want to
                            use to pay your Restaurant bill. To the extent permitted by applicable
                            law and subject to our privacy policy, you acknowledge and agree that we
                            may use certain third-party vendors and service providers to process
                            payments, manage debit and credit card information and detect and
                            prevent fraud. Neither Superb, the Restaurant nor the Payment Provider
                            is responsible for lost or stolen credit cards and/or
                            illegal/unauthorized use of your payment card information. By providing
                            debit or credit card account information through or to the Superb
                            Booking Application, you represent, warrant, and covenant that: (1) you
                            are legally authorized to provide such information to us; (2) you are
                            legally authorized to perform payments from the debit or credit card
                            account(s); and (3) such action does not violate the terms and
                            conditions applicable to your use of such debit or credit card
                            account(s) or applicable law. When you authorize a payment using a debit
                            or credit card account via the Superb Booking Application, you
                            represent, warrant, and covenant that there are sufficient funds or
                            credit available to complete a payment using the debit or credit card
                            account.
                        </p>
                    </li>

                    <li>
                        <h4>VERIFIED MOBILE PHONE NUMBER</h4>
                        <p>
                            In order to use the Payment Services, you must provide a valid mobile
                            phone number through the Superb Booking Application and verify such
                            number as instructed by us. If you change your mobile phone number, you
                            must promptly provide and verify your new mobile phone number. When you
                            provide your mobile phone number, you expressly consent to receive
                            direct dial calls, autodialed and prerecorded message calls, and text
                            messages relating to the Payment Services at that number.
                        </p>
                    </li>
                    <li>
                        <h4>ACCOUNT SETTINGS</h4>
                        <p>
                            You may establish certain default settings for your use of the Payment
                            Services through the Superb Booking Application, such as your preferred
                            payment card account if you provided debit or credit card information
                            directly through the Superb Booking Application. You may change these
                            settings through the Superb Booking Application.
                        </p>
                    </li>
                    <li>
                        <h4>RECEIPTS AND TRANSACTION HISTORY</h4>
                        <p>
                            As a courtesy, we will email a receipt to the email address associated
                            with your Account upon completion of a transaction using the Payment
                            Services. Furthermore we will send you confirmation by mobile text
                            message. You may print and save copies of these receipts. If you would
                            like a paper receipt, you must request one from the Restaurant at the
                            time of the transaction.
                        </p>
                    </li>
                    <li>
                        <h4>CERTAIN LIMITATIONS</h4>
                        <p>
                            You acknowledge and agree that Superb provides the Payment Services only
                            as a convenience and is not a party to your payment transactions
                            performed using the Payment Services. Superb is an independent
                            contractor for all purposes and is not your agent or trustee. Superb is
                            not responsible, and has no liability for, the products or services that
                            are paid for with the Payment Services. Superb is not responsible for
                            any overcharges or other payment disputes with Restaurants. Users must
                            resolve payment and other disputes directly with Restaurants. Superb is
                            not liable for any payments that the Payment Services do not complete
                            because: (1) your debit or credit card account does not contain
                            sufficient funds to complete the transaction or the transaction would
                            exceed the credit limit or overdraft protection of the debit or credit
                            card account; (2) you have not provided us with correct payment account
                            information; (3) your debit or credit card has expired; or (4)
                            circumstances beyond our control (such as, but not limited to, power
                            outages, interruptions of cellular service, or any other interferences
                            from an outside force) prevent the execution of the transaction. To the
                            extent that any amounts owed cannot be collected from your debit or
                            credit card account through the Payment Services Provider, you are
                            solely responsible for paying the applicable Restaurant(s) by other
                            means.
                        </p>
                    </li>
                    <li>
                        <h4>COMPLAINTS</h4>
                        <p>
                            In all cases where you process a payment and expect to receive
                            goods/services you are obliged to file any complaints or questions to
                            the restaurant only - who will handle your case.
                        </p>
                    </li>
                </ul>
            </div>
            <div>
                <h3 className="subtitle">TERMS OF ALL SERVICES</h3>
                <ul>
                    <li>
                        <h4>PRIVACY POLICY</h4>
                        <p>
                            Superb is committed to helping you safeguard your privacy online. Please
                            review our privacy policy for details about how we collect, use, and
                            disclose information in connection with the Services.
                        </p>
                    </li>
                    <li>
                        <h4>YOUR ACCOUNT</h4>
                        <p>
                            You may (but are not required to) create an account with Superb through
                            the Superb Site or Superb Booking Application (“Account”) in order to
                            use the Reservation Services or to purchase Tickets. You must have an
                            Account in order to use the Payment Services. When registering for an
                            Account, you must provide true, accurate, current, and complete data
                            about yourself on the Superb registration form (“Registration Data”).
                            You also agree to promptly update the Registration Data to keep it true,
                            accurate, current, and complete. You are solely responsible for
                            maintaining the confidentiality of your Account and the information in
                            your Account, and, except as otherwise required by applicable law, you
                            are solely responsible for all use of your Account, whether or not
                            authorized by you. You agree to immediately notify Superb of any
                            unauthorized use of your Account or any other breach of security related
                            to your use of the Services.
                        </p>
                    </li>

                    <li>
                        <h4>COMMUNICATION FROM SUPERB</h4>
                        <p>
                            The Superb Booking Application may use GPS locator capabilities to
                            identify your current location. If you provide a mobile phone number,
                            you hereby expressly consent to receive SMS text messages from Superb
                            regarding the Services and as otherwise described in our privacy policy.
                            The communication standards for the Services include, but are not
                            limited to: SMS, Email, GPS, and web-based browser technology. In order
                            to use the SMS-based Services, you must maintain an active account with
                            a carrier of electronic communications through mobile devices and you
                            may not use a prepaid cellular phone to access the Services.
                        </p>
                    </li>
                    <li>
                        <h4>TECHNICAL REQUIREMENTS</h4>
                        <p>
                            Use of the Services requires Internet access through your computer or
                            mobile device. You are responsible for all mobile carrier charges
                            resulting from your use of the Services, including from any
                            notifications provided by the Services. Superb does not guarantee that
                            the Services will be compatible with all devices or will be supported by
                            all mobile carriers. You may be required to have JavaScript (or similar
                            technologies) enabled to use the Superb Site, and some features and
                            portions of the Superb Site (including, but not limited to, making,
                            modifying, or canceling reservations) may not be accessible with
                            JavaScript disabled.
                        </p>
                    </li>
                    <li>
                        <h4>MODIFICATION TO SERVICES</h4>
                        <p>
                            Superb reserves the right, in its sole discretion, to modify the
                            Services from time to time and without notice, including, without
                            limitation, by removing, adding, or modifying portions of the Superb
                            Site, Superb Booking Application and Restaurants. Superb shall have no
                            liability to you for any of the foregoing actions. If you object to any
                            such changes, your sole recourse shall be to cease using the Services.
                            Continued use of the Services following any such changes shall indicate
                            your acknowledgment of such changes and satisfaction with all the
                            Services.
                        </p>
                    </li>
                    <li>
                        <h4>INTELLECTUAL PROPERTY RIGHTS AND GRANT OF RIGHTS TO USER</h4>
                        <p>
                            The features, information, and materials provided and depicted through
                            the Services are protected by copyright, trademark, patent, and other
                            intellectual property laws. All text, graphic content, video, data, and
                            other content made available through the Services (collectively, the
                            “Superb Content”) are provided to User by Superb or its partners or
                            licensors solely to support User's permitted use of the Services. The
                            Superb Content may be modified from time to time by Superb in its sole
                            discretion. Except as expressly set forth herein, no license is granted
                            to User for any other purpose, and any other use of the Services or the
                            Superb Content by User shall constitute a material breach of this
                            Agreement. Superb and its partners or licensors retain all rights in the
                            Services and Superb Content and any associated patents, trademarks,
                            copyrights, mask work rights, trade secrets, or other intellectual
                            property rights. No license, right, or interest in any trademarks of
                            Superb or any third party is granted under this Agreement.
                        </p>
                    </li>
                    <li>
                        <h4>APPLICATION LICENSE</h4>
                        <p>
                            Subject to the terms and conditions of this Agreement, Superb grants
                            User a non-exclusive, non-transferable, revocable license to use the
                            Superb Booking Application, in object code form only, on User's
                            compatible mobile devices, solely to support User's permitted use of the
                            Services.
                        </p>
                    </li>
                    <li>
                        <h4>USE RESTRICTIONS</h4>
                        <p>
                            The Services and Superb Content are offered solely for User's personal
                            use for the purposes described in this Agreement. Any and all other uses
                            are prohibited. Superb expressly reserves all its rights and remedies
                            under applicable state and federal laws. Superb reserves the right, in
                            its sole discretion, to refuse service, terminate Accounts, remove or
                            edit content, cancel reservations, or deny access to the Services. You
                            agree not to (and not to allow any third party to): (1) use any
                            deep-link, robot, spider, scraper, or other automatic or manual device,
                            process, or means to access, copy, search, or monitor any portion of the
                            Services or Superb Content, except as expressly authorized by Superb;
                            (2) take any action that imposes or may impose (in Superb's sole
                            determination) an unreasonable or a disproportionately large load on the
                            Services or Superb's infrastructure; (3) utilize any device, software,
                            or routine that will interfere or attempt to interfere with the
                            functionality of the Services; (4) rent, lease, copy, provide access to
                            or sublicense any portion of the Services or Superb Content to a third
                            party; (5) use any portion of the Services or Superb Content to provide,
                            or incorporate any portion of the Services or Superb Content into, any
                            product or service provided to a third party; (6) reverse engineer,
                            decompile, disassemble, or otherwise seek to obtain the source code or
                            non-public APIs to the Services, except to the extent expressly
                            permitted by applicable law (and then only upon advance notice to
                            Superb); (7) modify any Services or Superb Content or create any
                            derivative product from any of the foregoing; (8) remove or obscure any
                            proprietary or other notices contained in the Services or Superb
                            Content; (9) use the Services or Superb Content for any illegal purpose;
                            or (10) publicly disseminate information regarding the performance of
                            the Services or Superb Content or access or use the Services or Superb
                            Content for competitive analysis or benchmarking purposes.
                        </p>
                    </li>
                    <li>
                        <h4>TERMINATION</h4>
                        <p>
                            Superb may suspend your ability to use all or any element of the
                            Services or may terminate this Agreement effective immediately, without
                            notice or explanation. Without limiting the foregoing, Superb may
                            suspend your access to the Services if we believe you to be in violation
                            of any part of this Agreement (including any Superb Policies) or, with
                            respect to purchasers of Superb Tickets, if we receive excessive
                            chargebacks on the debit or credit card associated with your Account.
                            After any suspension or termination, you may or may not be granted
                            permission to use the Services or re-establish an Account. You agree
                            that Superb shall not be liable to you for any termination of this
                            Agreement or for any effects of any termination of this Agreement. You
                            are always free to discontinue your use of the Services at any time. You
                            understand that any termination of your Account may involve deletion of
                            any content stored in your Account for which Superb will have no
                            liability whatsoever.
                        </p>
                    </li>
                    <li>
                        <h4>REVIEWS, COMMENTS, COMMUNICATIONS, and OTHER CONTENT </h4>
                        <p>
                            The Services may permit you to submit reviews, comments, and ratings;
                            send emails and other communications; and submit suggestions, ideas,
                            comments, questions, or other information for publication and
                            distribution to restaurants and other third parties (“User Content”).
                            Any such User Content must not be illegal, obscene, racist, defamatory,
                            libelous, pornographic, infringing of intellectual property rights,
                            promoting of illegal activity or harm to groups and/or individuals,
                            invasive of privacy, purposely false or otherwise injurious to third
                            parties, or objectionable and must not consist of or contain software,
                            computer viruses, commercial solicitation, political campaigning, chain
                            letters, mass mailings, any form of “spam” or references to illegal
                            activity, malpractice, purposeful overcharging, false advertising, or
                            health code violations (e.g., foreign objects in food, food poisoning,
                            etc.). You may not use a false email address, impersonate any person or
                            entity, or otherwise mislead as to the origin of User Content. Superb
                            reserves the right (but has no obligation) to monitor, remove, or edit
                            User Content in Superb's sole discretion, including if User Content
                            violates this Agreement (including any Superb Policies), but you
                            acknowledge that Superb may not regularly review submitted User Content.
                            If you do submit User Content, and unless we indicate otherwise, you
                            grant Superb a nonexclusive, perpetual, royalty-free, irrevocable, and
                            fully sublicensable (through multiple tiers) right to use, modify,
                            reproduce, adapt, translate, publish, create derivative works from,
                            distribute, display, and otherwise exploit such User Content throughout
                            the world in any media. Superb takes no responsibility and assumes no
                            liability for any User Content submitted by you or any other User or
                            third party.
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default Terms;
